var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C6.486 4 2 8.486 2 14C1.99871 15.5434 2.35864 17.0656 3.051 18.445C3.221 18.785 3.567 19 3.946 19H20.053C20.432 19 20.779 18.785 20.949 18.445C21.6414 17.0656 22.0013 15.5434 22 14C22 8.486 17.514 4 12 4ZM19.41 17H4.59C4.19924 16.0481 3.99879 15.0289 4 14C4 9.589 7.589 6 12 6C16.411 6 20 9.589 20 14C20.0012 15.0289 19.8008 16.0481 19.41 17Z",
    fill: "#20A8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9387 12.9386C10.726 13.0777 10.5513 13.2677 10.4303 13.4912C10.3094 13.7148 10.2461 13.965 10.2461 14.2191C10.2461 14.4733 10.3094 14.7235 10.4303 14.947C10.5513 15.1706 10.726 15.3605 10.9387 15.4996C11.1068 15.6102 11.295 15.6866 11.4927 15.7243C11.6903 15.7621 11.8935 15.7605 12.0905 15.7196C12.2875 15.6787 12.4745 15.5994 12.6408 15.4861C12.8071 15.3729 12.9495 15.228 13.0597 15.0596L17.0217 9.02163C17.0249 9.01634 17.0266 9.01029 17.0266 9.00413C17.0266 8.99796 17.0249 8.99191 17.0217 8.98663C17.017 8.97942 17.0096 8.97433 17.0012 8.97247C16.9928 8.9706 16.984 8.97209 16.9767 8.97663L10.9387 12.9386Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.0f0912c80c975583b962aa719da35a03.svg";
export { ForwardRef as ReactComponent };